import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';

export class FeCmsNoticationTimer {
    private timerElement: HTMLElement | null = null;
    private readonly endDate: Date = new Date();

    constructor(className: string) {
        const timerElement = document.querySelector(`.${className} .countdown`);

        if (timerElement === null) {
            return;
        }

        this.timerElement = notNull(document.querySelector(`.${className} .countdown`)) as HTMLDivElement;

        const endDate = notNull(this.timerElement.getAttribute('date-until'));
        this.endDate = new Date(endDate + 'T23:59:59');

        this.initTimer();
    }

    private initTimer() {
        const updateTimer = () => {
            const currentTime = new Date();
            const timeLeft = this.endDate.getTime() - currentTime.getTime();

            if (timeLeft > 0) {
                this.timerElement!.innerText = this.formatTime(timeLeft);
            } else {
                this.timerElement!.innerText = '00d 00h 00m 00s';
                clearInterval(intervalId);
            }
        };
        const intervalId = setInterval(updateTimer, 1000);

        updateTimer();
    }

    private formatTime(milliseconds: number): string {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        hours %= 24;
        minutes %= 60;
        seconds %= 60;

        return `${days}d ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
    }
}
